// extracted by mini-css-extract-plugin
export default {"main":"BreadCrumbs_main__2U2ma","box":"BreadCrumbs_box__ZbGmv","menu_link":"BreadCrumbs_menu_link__XKa3Z","menu_text":"BreadCrumbs_menu_text__+5KSH"};